import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["replyForm", "shareForm"]
  static values = {
    title: String,
  }

  share(event) {
    event.preventDefault();

    navigator.share({
      title: this.titleValue,
      url: window.location.href
    });
  }

  toggleReplyForm(event) {
    event.preventDefault();
    this.replyFormTarget.classList.toggle("is-hidden");
  }

  toggleShareForm(event) {
    event.preventDefault();
    this.shareFormTarget.classList.toggle("is-hidden");
  }
}
